// Styles
import './css/desktop/app-desktop.scss';

import Popup from './js/utils/popup';
import WcagSettings from './js/components/wcag-settings';
import CartShort from './js/utils/cart-short';
import Pagination from './js/utils/pagination';

//-- zbędne jsy jeśli obsługa sal będzie inna

require('./jsy_do_widokow_z_salami/curve.js');
require('./jsy_do_widokow_z_salami/sale/parter_rows.js');
require('./jsy_do_widokow_z_salami/sale/amfiteatr_rows.js');
require('./jsy_do_widokow_z_salami/sale/balkon1.js');
require('./jsy_do_widokow_z_salami/sale/balkon2.js');
require('./jsy_do_widokow_z_salami/sale/balkon3.js');

//-- zbędne jsy jeśli obsługa sal będzie inna

//-- tooltipster
require('./js_wspolne/plugins/tooltipster.bundle.min.js');

$('.tooltip').tooltipster({
    contentAsHTML: true,
    interactive: true,
    minWidth: 1168,
    maxWidth: 1168,
    distance: 7,
    side: ['top'],
    trigger: 'click',
    functionPosition: function (instance, helper, position) {
        position.coord.left = (helper.geo.document.size.width - position.size.width) / 2;
        return position;
    },
});

$('.fr-close--tooltip').on('click', function (e) {
    e.preventDefault();
    $('.tooltip').tooltipster('close');
});

$('.tooltip-box').tooltipster({
    side: 'bottom',
    delay: 0,
    trigger: 'hover',
    maxWidth: 500,
    minWidth: 290,
});

//-- faktura osoba prywatna/firma
$('#invoice-radioboxes')
    .find('input')
    .change(function () {
        var private_person = $('#invoice-privat_person'),
            company = $('#invoice-company');

        if (private_person.is(':checked')) {
            $('.private_invoice').css('display', 'block');
            $('.company_invoice').css('display', 'none');
            $('#nip').css('display', 'none');
        }

        if (company.is(':checked')) {
            $('.private_invoice').css('display', 'none');
            $('.company_invoice').css('display', 'block');
            $('#nip').css('display', 'block');
        }
    });

(() => {
    if (typeof $ === 'undefined') {
        throw new TypeError('... requires jQuery.');
    }

    // Lazy loading
    function initLazyLoading() {
        const lazyLoadingElementList = [...document.querySelectorAll('[data-target="lazy-loading"]')];

        if (lazyLoadingElementList.length > 0) {
            import('./js/utils/lazy-loading').then((module) => {
                const lazyLoadingList = lazyLoadingElementList.map(function (image) {
                    let isInstanceExistsForNode = image.dataset.jsNodeInstance;

                    // Sprawdzamy, czy element posiada atrybut [data-js-node-instance="true"].
                    if (!Boolean(isInstanceExistsForNode)) {
                        image.setAttribute('data-js-node-instance', true);

                        return new module.LazyLoading(image);
                    }
                });
            });
        }
    }

    $(document).ready(() => {
        // Powiadomienia popup iKSORIS
        const popup = new Popup('', null, true, true);
        const colorSetting = new WcagSettings($('.wcag-settings__contrast a'), 'COLOR_THEME', 365, '', $('body'));
        const animationSetting = new WcagSettings($('.js-wcag-settings-animations-toggle'), 'ANIMATION', 365, '', $('html'));

        const pagination = new Pagination();

        colorSetting.init();
        animationSetting.init();
        pagination.init();

        // Podsumowanie koszyka popup
        window.cartShort = new CartShort();

        // Abonamenty - więcej
        $('.more-abonament').click(function (e) {
            e.preventDefault();
            $(this).parents('.spektakl__item').addClass('expand');
        });

        $('.less-abonament').click(function (e) {
            e.preventDefault();
            $(this).parents('.spektakl__item').removeClass('expand');
        });

        // Lazy loading
        initLazyLoading();

        const observedElements = [...document.querySelectorAll('#events-list')];

        if (observedElements.length > 0) {
            observedElements.forEach((targetNode) => {
                const observer = new MutationObserver((mutationList, observer) => {
                    initLazyLoading();
                });

                observer.observe(targetNode, { attributes: false, childList: true, subtree: false });
            });
        }
    });
})();

// Images
const requireContext = require.context('./images/', true, /^((?!miejsca).)*\.(gif|png|jpe?g|svg)$/i);

requireContext.keys().map(requireContext);
